import Vue from 'vue';
import VueRouter, {type Route} from 'vue-router';

Vue.use(VueRouter);

import Dashboard from '@/views/Dashboard.vue';

import DemoVideo from '@/components/DemoVideo.vue';
import Contract from '@/components/Contract.vue';
import Login from '@/views/Login.vue';

import TrainingTopColum from '@/views/TrainingTopColum.vue';
import TrainingUserInfo from '@/views/TrainingUserInfo.vue';
import TrainingChart from '@/views/TrainingChart.vue';

import AuditHistory from '@/views/AuditHistory.vue';
import AuditHistoryData from '@/views/AuditHistoryData.vue';

import TwoDMovies from '@/views/TwoDMovies.vue';
import TwoDMoviesUsers from '@/views/TwoDMoviesUsers.vue';

import YearOfDay from '@/views/YearOfDay.vue';

import Tmp from '@/views/temp.vue';
import News from '@/views/news.vue';

import TrainingRuntime from '@/views/TrainingRuntime.vue';

import store from '../store/index';

interface Breadcrumb {
  text: string;
  to?: string;
  disabled: boolean;
}

function dynamicYear(route: Route) {
  let main = true;
  if (route.query?.main === 'false') {
    main = false;
  }
  return {
    year: route.query.year,
    main: main,
  };
}

const routes = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: {requiresAuth: true},
    props: (route: Route) => ({
      maxYear: Number(route.query.maxYear),
      scopesCSV: route.query.scopes,
    }),
  },
  {
    path: '/news',
    component: News,
  },
  {
    path: '/tmp',
    component: Tmp,
    meta: {requiresAuth: true},
  },
  {
    path: '/year/:yearOfDay',
    component: YearOfDay,
    props: true,
    meta: {
      requiresAuth: true,
      breadcrumb: (route: Route): Breadcrumb[] => [
        {
          text: route.params?.yearOfDay
            ? `${route.params.yearOfDay}年度`
            : 'top',
          to: '/',
          disabled: true,
        },
        {
          text: '安全教育12項目',
          to: `/colum?main=true&year=${route.params?.yearOfDay}`,
          disabled: false,
        },
        {
          text: '年次計画表',
          disabled: true,
        },
      ],
    },
  },
  {
    path: '/chart/:id',
    component: TrainingChart,
    meta: {
      requiresAuth: true,
      breadcrumb: (route: Route): Breadcrumb[] => [
        {
          text: route.query?.year ? `${route.query.year}年度` : 'top',
          to: '/',
          disabled: true,
        },
        {
          text:
            route.query?.main === 'true' ? '安全教育12項目' : 'ヒヤリハット',
          to: `/colum?main=${route.query?.main}&year=${route.query?.year}`,
          disabled: false,
        },
        {
          text: '星取表',
          disabled: true,
        },
      ],
    },
    props: dynamicYear,
  },
  {
    path: '/2d',
    component: TwoDMovies,
    meta: {
      requiresAuth: true,
      breadcrumb: (route: Route): Breadcrumb[] => [
        {
          text: route.query?.year ? `${route.query.year}年度` : 'top',
          to: '/',
          disabled: true,
        },
        {
          text:
            route.query?.main === 'true' ? '安全教育12項目' : 'ヒヤリハット',
          to: `/colum?main=${route.query?.main}&year=${route.query?.year}`,
          disabled: false,
        },
        {
          text: '2D動画研修',
          disabled: true,
        },
      ],
    },
    props: dynamicYear,
  },
  {
    path: '/colum',
    component: TrainingTopColum,
    meta: {
      requiresAuth: true,
      breadcrumb: (route: Route): Breadcrumb[] => [
        {
          text: route.query?.year ? `${route.query.year}年度` : 'top',
          to: '/',
          disabled: true,
        },
        {
          text:
            route.query?.main === 'true' ? '安全教育12項目' : 'ヒヤリハット',
          to: `/colum?main=${route.query?.main}&year=${route.query?.year}`,
          disabled: true,
        },
        {
          text: '研修進捗状況',
          disabled: true,
        },
      ],
    },
    props: dynamicYear,
  },
  {
    path: '/2d/:id',
    component: TwoDMoviesUsers,
    meta: {
      requiresAuth: true,
    },
    props: dynamicYear,
  },
  {
    path: '/detail/:id',
    component: TrainingUserInfo,
    meta: {requiresAuth: true},
    props: dynamicYear,
  },
  {
    path: '/',
    redirect: {name: 'login'},
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/demo-video',
    name: 'demo-video',
    component: DemoVideo,
    meta: {requiresAuth: true},
  },
  {
    path: '/training-runtime',
    name: 'training-runtime',
    component: TrainingRuntime,
    meta: {requiresAuth: true},
    props: dynamicYear,
  },
  {
    path: '/audithistoryNew',
    name: 'audithistory',
    component: AuditHistory,
    meta: {requiresAuth: true},
  },
  {
    path: '/audithistory/:historyID',
    name: 'audithistoryWithID',
    component: AuditHistory,
    props: true,
    meta: {requiresAuth: true},
  },
  {
    path: '/contract',
    name: 'contract',
    component: Contract,
    meta: {requiresAuth: true},
  },
  {
    path: '/audithistoryData',
    name: 'audithistory-data',
    component: AuditHistoryData,
    meta: {requiresAuth: true},
  },
  {
    path: '/temp/:trainingID',
    name: 'temp',
    props: true,
    component: () => import('@/views/temp.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {x: 0, y: 0};
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(r => r.meta.requiresAuth) && !store.getters.isLogin) {
    next('/login');
  }
  next();
});

export default router;
